import { render, staticRenderFns } from "./ConFirmActionPayment.vue?vue&type=template&id=37bdbeb3"
import script from "./ConFirmActionPayment.vue?vue&type=script&lang=js"
export * from "./ConFirmActionPayment.vue?vue&type=script&lang=js"
import style0 from "./ConFirmActionPayment.vue?vue&type=style&index=0&id=37bdbeb3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports